import { ButtonHTMLAttributes, ReactNode } from 'react'
import { faFile, faPlus, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { msgItemIdCopied } from '../../../utils/messageToast'
import { LuCopy, LuDatabase, LuLayers, LuPlus, LuSave, LuSend, LuTicket } from 'react-icons/lu'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean
  buttonPublish?: boolean
  buttonSave?: boolean
  children?: ReactNode
  loadingButtonCreate?: boolean
}

export function ButtonAddGroup({ ...rest }) {
  return (
    <button type='button' title='Adicionar Grupo' className="header-buttons" {...rest}>
      <LuDatabase className="button-form-icon" />
      <span className="button-form-text">Novo Grupo</span>
    </button>
  )
}

export function ButtonAddFieldOutsideGroup({ ...rest }) {
  return (
    <button type='button' title='Adicionar campo padrão Fora de Grupo' className="header-buttons" {...rest}>
      <LuPlus className="button-form-icon" />
      <span className="button-form-text">Novo Campo</span>
    </button>
  )
}

export function ButtonAddAttachmentsFieldOutsideGroup({ ...rest }) {
  return (
    <button type='button' title='Adicionar campo de anexo Fora de Grupo' className="header-buttons" {...rest}>
      <LuLayers className="button-form-icon" />
      <span className="button-form-text">Novo Anexo</span>
    </button>
  )
}

export function ButtonSaveForm({ loading, buttonSave, ...rest }: ButtonProps) {
  return (
    <button title='Salvar Formulário' className={`button-save-form ${!buttonSave ? 'button-form-disabled' : ''
      }`} disabled={!buttonSave} {...rest}>
      {loading ? (
        <FontAwesomeIcon icon={faSpinner} spin />
      ) : (
        <>
          <LuSave className="button-form-icon" />
          <a className="button-form-text">Salvar</a>
        </>
      )}
    </button>
  )
}

export function ButtonPublishForm({ loading, buttonPublish, ...rest }: ButtonProps) {
  return (
    <button title='Publicar Formulário' disabled={!buttonPublish} className={`button-publish-form ${!buttonPublish ? 'button-form-disabled' : ''
      }`} {...rest}>
      {loading ? (
        <FontAwesomeIcon icon={faSpinner} spin />
      ) : (
        <>
          <LuSend className="button-form-icon" />
          <a className="button-form-text">Publicar</a>
        </>
      )}
    </button>
  )
}

export function ButtonGenerateJson({ loading, ...rest }: ButtonProps) {
  return (
    <button title='Gerar template do formulário' className="header-buttons" {...rest}>
      {loading ? (
        <FontAwesomeIcon icon={faSpinner} spin />
      ) : (
        <a className="button-form-text">Gerar Template</a>
      )}
    </button>
  )
}

export function ButtonGeneratePayload({ loading, ...rest }: ButtonProps) {
  return (
    <button title='Gerar payload de abertura de ticket' className="header-buttons" disabled={loading} {...rest}>
      {loading ? (
        <FontAwesomeIcon icon={faSpinner} spin />
      ) : (
        <a className="button-form-text">Gerar Payload</a>
      )}
    </button>
  )
}

export function ButtonCreateProtocol({ ...rest }: ButtonProps) {
  return (
    <button type='button' title='Abrir Ticket' className="button-ticket" {...rest}>
      <LuTicket className="button-form-icon" />
      <a className="button-form-text">Abrir Ticket</a>
    </button>
  )
}

export function ButtonCopyItemIdForm({ itemId, ...rest }: { itemId: string }) {
  const handleCopyItemIdForm = () => {
    navigator.clipboard.writeText(itemId);
    msgItemIdCopied("ItemId do formulário copiado para a área de transferência!");
  }
  return (
    <button type='button' title='Copiar ItemId do formulário' className="bg-button-copy-id-form" onClick={handleCopyItemIdForm} {...rest}>
      <LuCopy />
    </button>
  )
}

export function ButtonCopyIdForm({ formId, ...rest }: { formId: string | undefined }) {
  const handleCopyIdForm = () => {
    if (formId) {
      navigator.clipboard.writeText(formId);
      msgItemIdCopied("Id do formulário copiado para a área de transferência!");
    }
  }
  return (
    <button type='button' title='Copiar Id do formulário' className="bg-button-copy-id-form" onClick={handleCopyIdForm} {...rest}>
      <LuCopy />
    </button>
  )
}

export function ButtonCopyText({
  value,
  label,
  ...rest
}: { value?: string; label?: string } & ButtonHTMLAttributes<HTMLButtonElement>) {
  const handleCopy = () => {
    if (!value) return;
    navigator.clipboard.writeText(value);
    msgItemIdCopied(label || "Valor copiado para a área de transferência!");
  };
  return (
    <button
      type='button'
      title='Copiar valor'
      className="bg-button-copy-id-form"
      onClick={handleCopy}
      disabled={!value}
      {...rest}
    >
      <LuCopy />
    </button>
  );
}

export function ButtonAddFieldAttachments({ ...rest }) {
  return (
    <button type='button' title='Adicionar campo de anexo no grupo' className="header-buttons-fields" {...rest}>
      <FontAwesomeIcon icon={faFile} />
    </button>
  )
}

export function ButtonAddField({ ...rest }) {
  return (
    <button type='button' title='Adicionar campo padrão no grupo' className="header-buttons-fields" {...rest}>
      {/* <FontAwesomeIcon icon={faPlus} /> */}
      <FontAwesomeIcon icon={faPlus} />
    </button>
  )
}

export function ButtonCopyGroup({ ...rest }) {
  return (
    <button type='button' title='Duplicar Grupo' className="header-buttons-fields" {...rest}>
      <LuCopy />
    </button>
  )
}

export function ButtonRemoveGroup({ ...rest }) {
  return (
    <button type='button' title='Remover Grupo' className="header-buttons-fields-remove" {...rest}>
      <FontAwesomeIcon icon={faTrash} />
    </button>
  )
}

export function ButtonGetPathField({ ...rest }) {
  return (
    <button type='button' title='Copiar caminho do campo' className="header-buttons-fields" {...rest}>
      <LuCopy />
    </button>
  )
}

export function ButtonCreateFormPayload({ loadingButtonCreate, ...rest }: ButtonProps) {
  return (
    <button title='Criar Formulário' disabled={loadingButtonCreate} className="header-buttons" {...rest}>
      {loadingButtonCreate ? (
        <FontAwesomeIcon icon={faSpinner} />
      ) : (
        <a className="button-form-text">Criar Formulario</a>
      )}
    </button>
  )
}

export function ButtonTabulation({ loading, children, loadingButtonCreate, ...rest }: ButtonProps) {
  const isLoading = typeof loading !== 'undefined' ? loading : !!loadingButtonCreate;
  return (
    <button title='Tabular' className="header-buttons" {...rest}>
      {isLoading ? (
        <FontAwesomeIcon icon={faSpinner} spin />
      ) : (
        children ?? <a className="button-form-text">Tabular</a>
      )}
    </button>
  )
}

export function ButtonCreateSkills({ loadingButtonCreate, ...rest }: ButtonProps) {
  return (
    <button title='Criar habilidades' disabled={!loadingButtonCreate} className="header-buttons" {...rest}>
      {loadingButtonCreate ? (
        <FontAwesomeIcon icon={faSpinner} />
      ) : (
        <a className="button-form-text">Criar habilidades</a>
      )}
    </button>
  )
}

export function ButtonCopyReturn({ ...rest }: ButtonProps) {
  return (
    <button title='Copiar valor do retorno para area de transferencia' className="header-buttons" {...rest}>
      <a className="button-form-text">Copiar valor do retorno para area de transferencia</a>
    </button>
  )
}

export function ButtonPendency({ loading, children, ...rest }: ButtonProps) {
  return (
    <button title='Responder pendencia' className="header-buttons" {...rest}>
      <a className="button-form-text">Responder pendencia</a>
    </button>
  )
}

export function ButtonClearPendency({ ...rest }: ButtonProps) {
  return (
    <button title='Limpar pendencia' className="header-buttons" {...rest}>
      <a className="button-form-text">Limpar pendencia</a>
    </button>
  )
}